import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { PRIVATEPATHS } from '@core/enums/paths.enum';

const As2InboundGuide: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <div className="admin-motion-card rounded-md border border-slate-200 bg-slate-50">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="flex w-full items-center justify-between px-4 py-2.5 text-left text-sm font-semibold text-slate-700 hover:bg-slate-100"
            >
                <span>How to receive from a partner (inbound AS2)</span>
                <span className="text-slate-400">{open ? '▲' : '▼'}</span>
            </button>
            {open && (
                <div className="border-t border-slate-200 px-4 py-3 text-xs text-slate-700">
                    <p className="mb-3 text-slate-600">
                        Use direction <strong>RECEIVE</strong> or <strong>BIDIRECTIONAL</strong> when adding the partner.
                        <strong> Test URL</strong> only checks outbound reachability — it does not test inbound receive.
                    </p>
                    <ol className="list-decimal space-y-1.5 pl-4">
                        <li>
                            Set <strong>inbound URLs</strong> in Integration platform settings — include{' '}
                            <code className="font-mono">/as2/HttpReceiver</code>.
                        </li>
                        <li>
                            <Link to={PRIVATEPATHS.Integrations} className="text-[#bd902e] hover:underline">
                                Add partner
                            </Link>{' '}
                            → direction RECEIVE or BIDIRECTIONAL → enter AS2 ID, upload production cert, link
                            supplier.
                        </li>
                        <li>
                            Give the partner: Antar inbound URL, Antar AS2 ID (
                            <code className="font-mono">ANTAR-AS2-TEST</code> for pre-go-live,{' '}
                            <code className="font-mono">ANTAR-AS2</code> for production — from platform settings),
                            and Antar public certificate.
                        </li>
                        <li>Partner sends AS2 → verify the payload appears under OpenAS2 inbox.</li>
                        <li>
                            <Link to={PRIVATEPATHS.As2Messages} className="text-[#bd902e] hover:underline">
                                AS2 Messages
                            </Link>{' '}
                            → filter <strong>IN</strong> + <strong>Awaiting admin review</strong> → Approve/Reject.
                        </li>
                    </ol>
                </div>
            )}
        </div>
    );
};

export default As2InboundGuide;
